module.exports = __webpack_public_path__ + "images/257b29d.jpg";